import client from '../client';
import queryString from 'query-string';

export type TBcType = 'hres' | 'ens' | null;
export type DatasetProvider = 'ecmwf' | 'cams' | 'c3s';

export type TApiSubset = {
  id: number;
  set_id: number;
  url: string;
  set: string;
  name: string;
  title: string;
  tooltip: string;
  type: string;
  list_of_choices: Array<string>;
  options: string;
  bc_type: TBcType;
  provider: DatasetProvider;
  hindcast: boolean;
}

type TApiSubsetListParams = {
  paramShortnames: Array<string>
}

const list = (params: TApiSubsetListParams): Promise<Array<TApiSubset>> =>
  client.get('/subset/', {
    params: {
      param: params.paramShortnames
    },
    paramsSerializer: params => queryString.stringify(params)
  }).then(response => response.data);

const fetch = (id: string | number): Promise<TApiSubset> =>
  client.get(`/subset/${id}/`).then(response => response.data);

export {
  fetch,
  list
}
